import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Hotel, ShoppingCart, User, LogOut, Menu, X } from 'lucide-react';
import { logoutUser } from '../utils/auth';
import SessionStatus from './SessionStatus';

const Navbar = ({ user, setUser, cartItems = [], onBookRoomsClick, onContactUsClick }) => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
  console.log('Navbar - User:', user);
  console.log('Navbar - Cart items:', cartItems);
  console.log('Navbar - Cart length:', cartItems.length);

  const handleLogout = () => {
    logoutUser(setUser, null, navigate, false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <Hotel size={28} />
          <span>Hotel The Container</span>
        </Link>

        {/* Mobile Menu Toggle */}
        <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Desktop Menu */}
        <div className="nav-menu desktop-menu">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/rooms" className="nav-link">Rooms</Link>
          <button 
            onClick={onBookRoomsClick} 
            className="nav-link nav-button"
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', fontSize: 'inherit', fontFamily: 'inherit' }}
          >
            Book Rooms
          </button>
          <Link to="/gallery" className="nav-link">Gallery</Link>
          <button 
            onClick={onContactUsClick} 
            className="nav-link nav-button"
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', fontSize: 'inherit', fontFamily: 'inherit' }}
          >
            Contact Us
          </button>
          {user ? (
            <div className="nav-user-section">
              {user.role === 'admin' && (
                <Link to="/admin" className="nav-link">Admin Panel</Link>
              )}
              {user.role !== 'admin' && (
                <Link to="/profile" className="nav-link">Profile</Link>
              )}
              <Link to="/cart" className="nav-link cart-link">
                <ShoppingCart size={20} />
                {cartItems.length > 0 && (
                  <span className="cart-badge">{cartItems.length}</span>
                )}
              </Link>
              
              <SessionStatus user={user} />
              
              <div className="nav-user">
                <User size={20} />
                <span>{user.name}</span>
                <button onClick={handleLogout} className="logout-btn">
                  <LogOut size={16} />
                </button>
              </div>
            </div>
          ) : (
            <div className="nav-auth">
              <Link to="/login" className="nav-link">Login</Link>
              {/* <Link to="/register" className="nav-link register-btn">Register</Link> */}
            </div>
          )}
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="mobile-menu">
            <div className="mobile-menu-content">
              <Link to="/" className="mobile-nav-link" onClick={closeMobileMenu}>Home</Link>
              <Link to="/rooms" className="mobile-nav-link" onClick={closeMobileMenu}>Rooms</Link>
              <button 
                onClick={() => { onBookRoomsClick(); closeMobileMenu(); }} 
                className="mobile-nav-link"
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', fontSize: 'inherit', fontFamily: 'inherit', width: '100%', textAlign: 'left', padding: '12px 0' }}
              >
                Book Rooms
              </button>
              <Link to="/gallery" className="mobile-nav-link" onClick={closeMobileMenu}>Gallery</Link>
              <button 
                onClick={() => { onContactUsClick(); closeMobileMenu(); }} 
                className="mobile-nav-link"
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', fontSize: 'inherit', fontFamily: 'inherit', width: '100%', textAlign: 'left', padding: '12px 0' }}
              >
                Contact Us
              </button>
              
              {user ? (
                <>
                  {user.role === 'admin' && (
                    <Link to="/admin" className="mobile-nav-link" onClick={closeMobileMenu}>Admin Panel</Link>
                  )}
                  {user.role !== 'admin' && (
                    <Link to="/profile" className="mobile-nav-link" onClick={closeMobileMenu}>Profile</Link>
                  )}
                  <Link to="/cart" className="mobile-nav-link" onClick={closeMobileMenu}>
                    <div className="mobile-cart-link">
                      <ShoppingCart size={20} />
                      <span>Cart</span>
                      {cartItems.length > 0 && (
                        <span className="cart-badge">{cartItems.length}</span>
                      )}
                    </div>
                  </Link>
                  
                  <div className="mobile-user-section">
                    <div className="mobile-user-info">
                      <User size={20} />
                      <span>{user.name}</span>
                    </div>
                    <button onClick={() => { handleLogout(); closeMobileMenu(); }} className="mobile-logout-btn">
                      <LogOut size={16} />
                      <span>Logout</span>
                    </button>
                  </div>
                </>
              ) : (
                <div className="mobile-auth-section">
                  <Link to="/login" className="mobile-nav-link" onClick={closeMobileMenu}>Login</Link>
                  {/* <Link to="/register" className="mobile-nav-link mobile-register-btn" onClick={closeMobileMenu}>Register</Link> */}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
